// loaders
export const WALLET_HISTORY_TABLE_LOADER = 'walletHistoryTableLoader'
export const PATIENT_REWARDS_TABLE_LOADER = 'patientRewardsTableLoader'
